import React, { FunctionComponent, useState, useEffect } from 'react';
import Styles from 'components/customModal/CustomModal.module.scss';
import crossImage from 'assets/images/cross.png'

interface CustomModalProps {
  closeDialog?: (event?: React.FormEvent<HTMLDivElement>) => void;
  cssClass?: string;
  wrapperClass?: string;
  heightClass?: string;
  title?: string;
  children: any;
  modalTitleClass?: string;
  modalTitle?: string;
  closeModal?: (event?: React.FormEvent<HTMLDivElement>) => void;
  close?: boolean;
  isOpen?: boolean;
}

const CustomModal: FunctionComponent<CustomModalProps> = (props: CustomModalProps) => {
  const { children, cssClass, closeDialog, title, wrapperClass, heightClass, modalTitleClass, modalTitle, closeModal, close, isOpen } = props;
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen !== undefined && !isOpen) {
      setIsClosing(true);
    } else {
      setIsClosing(false);
    }
  }, [isOpen]);

  const handleClose = (event?: React.FormEvent<HTMLDivElement>) => {
    if (closeDialog) {
      closeDialog(event);
    }
  };

  const handleCloseModal = (event?: React.FormEvent<HTMLDivElement>) => {
    if (closeModal) {
      closeModal(event);
    }
  };

  return (
    <>
      <section className={`${Styles.modalWrapper} ${wrapperClass} ${isClosing ? Styles.fadeOut : Styles.fadeIn}`}>
        <div className={Styles.modalContent}>
          {close && (
            <div
              className={`${Styles.closeButtonWrapper} d-flex flex-row-reverse`}
              onClick={handleCloseModal}
              onKeyPress={handleCloseModal}
              role="button"
              tabIndex={0}
            >
              <img
                src={crossImage}
                alt="close"
                className={Styles.superHostImg}
              />
            </div>
          )}
          <div className={Styles.modalHeader}>
            <div className={`font-weight-600 ${Styles.modalFirstTitle} ${modalTitleClass} text-center`}>{modalTitle}</div>
            <h4 className={`font-weight-600 ${Styles.modalTitle} ${modalTitleClass} text-center`}>{title}</h4>
          </div>
          <div className={`${Styles.modalBody} ${cssClass} ${heightClass} customBodyScroll`}>{children}</div>
        </div>
      </section>
      <div className={`${Styles.modalBgLayer} ${isClosing ? Styles.fadeOut : Styles.fadeIn}`} onClick={handleClose} onKeyPress={handleClose} role="button" tabIndex={0} />
    </>
  );
};

export default CustomModal;
